module.exports = __webpack_public_path__ + "static/media/dingdan.49869b4a.png";